import * as React from 'react';

import cx from 'classnames';

import Avatar from 'components/Avatar';
import Group from 'entities/Group';
import Organization from 'entities/Organization';
import { RosterGroupSummary } from 'setup/components/SetupRosterConfirm';

import './styles/GroupAvatar.scss';

export type Props = {
  group?: FullExpectedGroup;
  size?: 'xxsmall' | 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';
  className?: string;
  onClick?: (event: React.SyntheticEvent) => any;
};

export type FullExpectedGroup = GroupModels | GroupPropType;

export type GroupModels = Group | Organization | RosterGroupSummary;

export type GroupPropType = { groupAvatar?: { svg_url?: string | null }; initials?: string };

class GroupAvatar extends React.Component<Props> {
  render() {
    const { className, group, size, ...others } = this.props;

    if (!group) {
      return null;
    }

    const getUrl = (g: FullExpectedGroup) => {
      if ('groupAvatar' in g && g.groupAvatar && g.groupAvatar.svg_url) {
        return g.groupAvatar.svg_url;
      } else if ('getAvatarUrl' in g) {
        return g.getAvatarUrl();
      }
    };

    const url = getUrl(group);
    if (url) {
      return (
        <Avatar
          {...others}
          className={cx('GroupAvatar', size && `GroupAvatar--${size}`, className)}
          image={url}
        />
      );
    } else if ('initials' in group) {
      return (
        <Avatar
          {...others}
          className={cx('GroupAvatar', size && `GroupAvatar--${size}`, className)}
          text={group.initials}
        />
      );
    } else {
      return null;
    }
  }
}

export default GroupAvatar;
